import moment from 'moment';

export const formatDate = ({ date, format = 'MM/DD/YYYY', tz = null }) => {
  return moment(date, tz).format(format);
};
